window.addEventListener("load", function () {
  document.body.classList.remove("init");

  function preloadImage(url, img) {
    img.src = url;
  }

  const images = document.querySelectorAll("img[data-imgSrc], img[data-src]");
  images.forEach((img) => {
    const imgSrc =
      img.getAttribute("data-imgSrc") || img.getAttribute("data-src");
    if (imgSrc) {
      preloadImage(imgSrc, img);
    }
  });

  inView(".in-view").on("enter", (section) =>
    section.classList.add("in-view--visible")
  );
});
